<template>
  <div v-if="loading || loadingFiltros">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <v-card-title>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-flex xs2 pr-2 mr-2>
          <v-autocomplete v-model="filterEstado" label="Estado" :items="estados" clearable dense
              item-text="text" item-value="value" multiple>
            <template slot="selection" slot-scope="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <span v-if="index === 1" class="text-grey">&nbsp;(+{{ filterEstado.length - 1 }} más)</span>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs2 pr-2 mr-2>
          <v-text-field v-model="filterPersona" append-icon="search" clearable small
              label="Nombre y/o apellido" single-line hide-details></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      hide-actions
      class="elevation-1"
      disable-initial-sort
      :pagination.sync="customPagination"
      :items="filteredItems"
      ref="dataTable">
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="primary-table verticalLine header-row"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template slot="no-data">
        <div class="text-xs-center" v-if="loading">Cargando datos...</div>
        <div class="text-xs-center" v-else>No hay datos disponibles</div>
      </template>
      <template
        slot="items"
        slot-scope="props"
        class="primary-table verticalLine">
        <tr :class="props.item.estado === 3 && $store.getters.isClubRole? 'diferencia-importe': ''">
          <td class="item-cell">{{ props.item.jugador.lastName }}</td>
          <td class="item-cell">{{ props.item.jugador.firstName }}</td>
          <td class="item-cell">
            <span class="d-inline-block text-no-wrap">
              {{ truncarTexto(props.item.condicionSalarial.conceptoDisplay) }}
            </span>
          </td>
          <td class="item-cell">
            {{ props.item.monedaDisplay }}
            <v-tooltip bottom v-if="props.item.condicionSalarial.descripcionTipoDeCambio && $store.getters.isSafeRole">
              <v-icon small slot="activator">info</v-icon>
              <span>
                Descripción Tipo de Cambio:
                <br/>
                {{ props.item.condicionSalarial.descripcionTipoDeCambio }}</span>
            </v-tooltip>
          </td>
          <td class="item-cell importe-cell">{{ props.item.tipoDeCambio ? formatAsCurrency(props.item.tipoDeCambio) : "-" }}</td>
          <td class="item-cell importe-cell">{{ props.item.moneda == 0 ? formatAsCurrency(props.item.importeBruto) : formatAsCurrency(props.item.importeBrutoExtranjero)}}</td>
          <td class="item-cell importe-cell">{{ props.item.moneda == 0 ? formatAsCurrency(props.item.importeNeto) : formatAsCurrency(props.item.importeNetoExtranjero)}}</td>
          <td class="item-cell importe-cell" :class="props.item.importeEsValido ? 'columna-lpf' : 'columna-lpf-con-diferencias'" v-if="$store.getters.isSafRole">
            {{ props.item.condicionSalarial.importeBrutoDisplay != "0" ? formatAsCurrency(props.item.condicionSalarial.importeBrutoDisplay) : "-" }}
          </td>
          <td class="item-cell importe-cell" :class="props.item.importeEsValido ? 'columna-lpf' : 'columna-lpf-con-diferencias'" v-if="$store.getters.isSafRole">
            {{ props.item.condicionSalarial.importeNetoDisplay != "0" ? formatAsCurrency(props.item.condicionSalarial.importeNetoDisplay) : "-" }}
          </td>
          <td class="item-cell importe-cell" v-if="$store.getters.isSafRole">{{ formatAsCurrency(props.item.diferencia) }}</td>
          <td class="item-cell center-cell">
            <div class="col-2 row-element text-no-wrap">
              <detalle-pagos-popup :adjuntos="props.item.comprobantes"></detalle-pagos-popup>
            </div>
          </td>
          <td class="item-cell">{{ props.item.estadoDisplay }}</td>
          <td class="item-cell"><PagosListActionButtons :item="props.item"></PagosListActionButtons></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { paginationMixin } from '../../../mixins/paginationMixin'
import PagosListActionButtons from './PagosListActionButtons'
import DetallePagosPopup from './DetallePagosPopup'

export default {

  mixins: [paginationMixin],

  components: {
    PagosListActionButtons,
    DetallePagosPopup
  },

  data () {
    return {
      path: `/pagos/${this.$route.params.id}`,
      estados: [],
      loadingFiltros: false,
      filtersPath: `/filters/pagos/`,
      filterPersona: '',
      filterEstado: [],
      customPagination: {
        page: 1,
        descending: false,
        rowsPerPage: -1
      }
    }
  },

  methods: {
    fetchFilters () {
      this.loadingFiltros = true
      this.axios
        .get(this.filtersPath)
        .then(response => {
          this.loadingFiltros = false
          this.estados = response.data.filters[0].items
        })
        .catch(error => {
          this.loadingFiltros = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    formatAsCurrency (importe) {
      return Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    setItems (responseData) {
      this.items = responseData
    },
    fetchData (refreshing = false) {
      if (!refreshing) {
        this.loading = true
      }
      this.axios
        .get(this.path)
        .then(response => {
          this.setItems(response.data)
          this.setPageFromStore()
          this.totalItems = response.data.count
          this.loading = false
        })
        .catch(error => {
          let validError = error && error.response && error.response.data && error.response.data.detail
          if (validError && error.response.data.detail.includes('Página inválida')) {
            this.setPageAndStore(1)
          } else {
            this.$store.commit('setErrorMsg', error)
          }
        })
    },
    refreshTable () {
      this.fetchData(true)
    },
    truncarTexto (texto) {
      const cantidadLetras = this.cantidadDeLetras
      if (texto.length > this.cantidadDeLetras) {
        return texto.substring(0, cantidadLetras) + '...'
      }
      return texto
    },
    changeSort (column) {
      if (this.customPagination.sortBy === column) {
        this.customPagination.descending = !this.customPagination.descending
      } else {
        this.customPagination.sortBy = column
        this.customPagination.descending = false
      }
    },
    filtrarPorPersona (item) {
      if (!this.filterPersona) return true
      const nombreYApellido = `${item.jugador.firstName} + ${item.jugador.lastName}`.toLowerCase()
      const nombresFiltro = this.filterPersona.toLowerCase().split(' ')
      return nombresFiltro.every(nombre => nombreYApellido.includes(nombre))
    },
    filtrarPorEstado (item) {
      if (!this.filterEstado.length) return true
      return this.filterEstado.includes(item.estado)
    }
  },

  created () {
    this.fetchData()
    this.fetchFilters()
  },

  computed: {
    filteredItems () {
      if (!this.filterEstado.length && !this.filterPersona) return this.items

      return this.items.filter(item => this.filtrarPorPersona(item) && this.filtrarPorEstado(item))
    },
    cantidadDeLetras () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 6
        case 'sm': return 7
        case 'md': return 8
        case 'lg': return 9
      }
      return 15
    },
    headers () {
      let headers = [
        { text: 'Apellido', value: 'jugador.lastName' },
        { text: 'Nombre', value: 'jugador.firstName' },
        { text: 'Concepto', value: 'condicionSalarial.conceptoDisplay' },
        { text: 'Moneda', value: 'monedaDisplay' },
        { text: 'Tipo de Cambio', value: 'tipoDeCambio' },
        { text: 'Imp. Bruto Club', value: 'importeBruto' },
        { text: 'Imp. Neto Club', value: 'importeNeto' },
        { text: 'Comprobantes', value: 'comprobantes', sortable: false },
        { text: 'Estado', value: 'estadoDisplay' },
        { text: 'Acciones', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(7, 0, { text: 'Imp. Bruto LPF', value: 'condicionSalarial.importeBrutoDisplay' })
        headers.splice(8, 0, { text: 'Imp. Neto LPF', value: 'condicionSalarial.importeNetoDisplay' })
        headers.splice(9, 0, { text: 'Diferencia', value: 'diferencia' })
      }
      return headers
    }
  }
}
</script>
<style scoped>
  .header-row{
    background-color: #5a7db6;
    font-weight: bold;
  }
  .columna-lpf{
    background-color: rgb(189, 189, 189);
  }
  .columna-lpf-con-diferencias{
    background-color: rgb(231, 188, 108);
  }
  .adjunto {
    font-size: small;
    padding-top: 0.4em;
    padding-bottom: 0.4em;
    color: darkslateblue;
  }
  .diferencia-importe {
    background-color: wheat;
  }
  .primary-table {
    padding: 0 0 0 0 !important;
    margin: 0 0 0 0 !important;
  }
  .verticalLine {
    border-left: 0.2em solid black;
    border-right: 0.2em solid black;
    border-top: 0.2em solid black;
    border-bottom: 0.2em solid black;
  }
  .importe-cell {
    text-align: right;
  }
  .center-cell {
    text-align: center;
  }
  .item-cell {
    border-left: 0.1em solid gray;
    border-right: 0.1em solid gray;
  }
  table.v-table tbody td, table.v-table tbody th {
    height: 40px;
  }
</style>
